<p-dialog modal="true" styleClass="atlas-dialog-xl" position="top" [closable]="false" [(visible)]="show">
  <ng-template pTemplate="header">
    <h4>
      {{ 'committees.edit.committee-members.group-add-dialog.header' | translate | titlecase }}
    </h4>
  </ng-template>

  <wl-profile-advanced-search-options [searchParams]="searchParams" [hideRunThisSearchButton]="true"></wl-profile-advanced-search-options>

  <div class="mv-21 mct-flex mct-row mct-justify-end mct-items-center">
    <button type="button" class="atlas-btn atlas-btn-primary" (click)="searchGrid.search()">
      {{ 'committees.edit.committee-members.run-this-search' | translate | uppercase }}
    </button>
  </div>

  <wl-committee-member-profile-grid
    #searchGrid
    [(searchParams)]="searchParams"
    [preventInitialLoad]="true"
  ></wl-committee-member-profile-grid>

  <ng-template pTemplate="footer">
    <div class="mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-justify-end mct-items-center mct-gap-50">
      <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10">
        <label>{{ 'committees.edit.committee-members.group-add-dialog.committee-start-date' | translate | ucfirst }}</label>
        <wl-date-selector [(ngModel)]="bulkAddDto.StartDate"></wl-date-selector>
      </div>
      <div class="mct-flex mct-row mct-gap-10">
        <button type="button" class="atlas-btn atlas-btn-secondary" [disabled]="isAdding" (click)="close()">
          {{ 'common.cancel' | translate | uppercase }}
        </button>
        <button type="button" class="atlas-btn atlas-btn-primary" [disabled]="isAdding" (click)="addProfilesToCommittee()">
          {{ 'committees.edit.committee-members.group-add-dialog.add-these-profiles' | translate | uppercase }}
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>
